import { useLocation } from 'react-router'

import { PageFields } from '@tribeplatform/gql-client/graphql'
import { Page } from '@tribeplatform/gql-client/types'
import { useCachedSpace, usePage } from '@tribeplatform/react-sdk/hooks'
import { UseQueryOptions } from '@tribeplatform/react-sdk/lib'
import { decodeURIPath } from '@tribeplatform/react-sdk/utils'

export const useCurrentPage = (options?: {
  fields?: PageFields
  useQueryOptions?: UseQueryOptions<Page>
}) => {
  const location = useLocation()
  let path
  try {
    path = decodeURIPath(location.pathname)
  } catch (e) {
    path = location.pathname
  }

  const cachedSpace = useCachedSpace({ path })
  const query = usePage({
    variables: { path },
    fields: options?.fields,
    useQueryOptions: {
      enabled: typeof path === 'string',
      notifyOnChangeProps: ['data', 'error'],
      keepPreviousData: false,
      ...options?.useQueryOptions,
    },
  })

  return {
    ...query,
    data:
      (!query.data || query.isPreviousData) && cachedSpace
        ? ({ space: cachedSpace } as Page)
        : query.data,
  }
}
